<template>
    <div class="login">
        <div class="center-box">
            <img
                class="center-box__logo"
                :src="logoNavyHorizontal"
                alt="Slingshot Logistics Logo"
            >
            <TheAuthBox
                key="1"
                v-if="!userAuthorized"
                class="content-box"
                :next="next"
                @authorized="setUserAuthorized( true )"
            />
            <TheLocationBox
                key="2"
                v-else
                class="content-box"
                @cancel="setUserAuthorized( false )"
            />
        </div>
    </div>
</template>

<script>
// Assets
import logoNavyHorizontal from '@/assets/images/logo-navy-horizontal.svg';

// Components
import TheAuthBox from './login/TheAuthBox';
import TheLocationBox from './login/TheLocationBox';

export default {
    name: 'Login',
    components: {
        TheAuthBox,
        TheLocationBox,
    },
    props: {
        /* Query param that is the 'next' page to redirect to upon successful login */
        next: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            logoNavyHorizontal,
            userAuthorized: false,
            showToast: true,
        };
    },
    methods: {
        setUserAuthorized( boolean ) {
            this.userAuthorized = boolean;
        },
    },
};
</script>

<style lang="scss" scoped>
    .login {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .center-box {
            @include mixins-above(desktop) {
                width: 40vw;
            }

            &__logo {
                margin-bottom: 6vh;
                width: 100%;
                height: auto;
            }
        }
    }
</style>
